import * as React from 'react';
export const unionpaySvg = React.forwardRef(function unionpaySvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
      },
      /*#__PURE__*/ React.createElement('path', {
        d: 'M3.162 0h4.03c.562 0 .911.545.78 1.215l-1.876 9.571C5.964 11.455 5.401 12 4.838 12H.808c-.56 0-.912-.545-.78-1.214l1.876-9.57C2.036.544 2.6 0 3.162 0',
        fill: '#F03',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M6.66 0h4.997c.552 0 .303.545.173 1.215l-1.843 9.571C9.86 11.455 9.9 12 9.345 12H4.35c-.553 0-.896-.545-.766-1.214l1.843-9.57C5.556.544 6.108 0 6.66 0',
        fill: '#036',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M15.191 0c.563 0 .913.545.781 1.215l-1.876 9.571C13.964 11.455 13.4 12 12.837 12H8.353c-.564 0-.914-.545-.781-1.214l1.876-9.57C9.578.544 10.14 0 10.705 0h4.486z',
        fill: '#066',
      }),
    ),
  );
});
unionpaySvg.defaultProps = {
  width: '16',
  height: '12',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var unionpay = {
  category: 'card',
  colorable: false,
  name: 'unionpay',
  svg: unionpaySvg,
};
